export const setSettings = (payload) => {
  return {
    type: 'SET_SETTINGS',
    payload,
  };
};
